export default __webpack_public_path__ + "static/media/icPhone.067e2809.svg";